/**
 * Validation types.
 */
var ValidationTypes =
/** @class */
function () {
  function ValidationTypes() {}
  /**
   * Checks if validation type is valid.
   */


  ValidationTypes.isValid = function (type) {
    var _this = this;

    return type !== "isValid" && type !== "getMessage" && Object.keys(this).map(function (key) {
      return _this[key];
    }).indexOf(type) !== -1;
  };
  /* system */


  ValidationTypes.CUSTOM_VALIDATION = "customValidation"; // done

  ValidationTypes.NESTED_VALIDATION = "nestedValidation"; // done

  ValidationTypes.PROMISE_VALIDATION = "promiseValidation"; // done

  ValidationTypes.CONDITIONAL_VALIDATION = "conditionalValidation"; // done

  ValidationTypes.WHITELIST = "whitelistValidation"; // done

  ValidationTypes.IS_DEFINED = "isDefined"; // done

  return ValidationTypes;
}();

export { ValidationTypes };